import { render, staticRenderFns } from "./SurveyFillerStart.vue?vue&type=template&id=38b78626&scoped=true"
import script from "./SurveyFillerStart.vue?vue&type=script&lang=js"
export * from "./SurveyFillerStart.vue?vue&type=script&lang=js"
import style0 from "./SurveyFillerStart.vue?vue&type=style&index=0&id=38b78626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b78626",
  null
  
)

export default component.exports